import React, { Component } from 'react';
import logo from './logo.png';
import { Link } from "react-router-dom";
import zagbanya from'../img/banya.png';
import headimage from'../img/kosdom-header.png';
import banyarabota from'../img/banyarabota.jpg';


const iframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/2ypcX4Ysupg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

const active = {
  color: 'FireBrick',
  fontSize: '24px',
  textDecoration: 'none',
};

const menu = {
  color: 'black',
  fontSize: '24px',
  textDecoration: 'none',
};

function Iframe(props) {
  return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
}

export default class Zagbanya extends Component {
  render() {
    return (
        <div className="container">
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6"><img src={headimage} className="img-fluid"/></div>
        </div>
        <div className="row p-0 overflow-hidden p-3 mt-3"  style={{backgroundColor: '#f3eeea', borderRadius:10}}  >
          <div className="col-md-2"></div>
          <div className="col-md-2"><Link to="/" style={menu}> Услуги </Link></div>
          <div className="col-md-3"><img src={logo} 
                height="30"
                width="30"
                className="d-inline-block align-center"
                alt="logo"
                /><Link to="/banya" style={active} > Рубленые бани </Link></div>
          <div className="col-md-3"><Link to="/brus" style={menu}  > Дома и бани из бруса  </Link></div>
        </div>
        <div className="row p-0 overflow-hidden h-80 shadow p-3 mt-3" style={{borderRadius:10}}>
        <div className="col-md-4"><img src={zagbanya} width="370px"  /></div>
          <div className="col-md-8">
             Бригада квалифицированных <u>русских</u> рабочих из <strong>Костромской области</strong> предлагает <strong>рубленые бани</strong> собственного производства.
             Проектирование, изготовление, доставка, строительство. <br />
             Гарантированные качество и сроки! <br />
             Работаем на всей территории центральной части России: <strong>Костромская, Ярославская, Московская, 
             <br  /> Владимирская, Ивановская, Тульская, Липецкая, Ленинградская области.</strong><br /> 
             телефон: <strong><span style={{color: "#0FB920", fontSize: "24px"}}>8-964-155-84-90</span></strong> Алексей <br />
          </div>
        </div>
    </div>
    )
  }
}
